
// ******************
//
// Ver.1.0
// Released on: Nov 15, 2023
// Phase 1.5
//
// ******************
import Vue from 'vue'
import ButtonCustom from '@/components/common_new/button-custom/index.vue'
import Title from '@/components/common_new/popup/title.vue'
import { ListNamePopup } from '@/shared/enums'
import { mapGetters } from 'vuex'

export default Vue.extend({
    name: 'ErrorRateProvider',
    components: { ButtonCustom, Title },
    computed: {
        ...mapGetters('popup', ['getParamsPopup'])
    },
    methods: {
        backPage() {
            this.$store.dispatch('popup/openPopup', {
                isOpen: true,
                namePopup: ListNamePopup.AdvisorRateProvider,
                payload: {
                    id: this.getParamsPopup?.idProduct,
                    provider_id: this.getParamsPopup?.idProvider
                }
            })
        }
    }
})
